<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col size="12" class="ion-align-self-center">
      <ion-label class="panel-header-text" color="dark">
        {{ 'devices_title' | translate }}
      </ion-label>
    </ion-col>
  </ion-row>

  @if (disableForm()) {
    <ion-row>
      <ion-col>
        <admin-core-lib-installation-no-access />
      </ion-col>
    </ion-row>
  } @else if (ctdLimitReached()) {
    <ion-row>
      <ion-col>
        <admin-core-lib-installation-ctd-limit />
      </ion-col>
    </ion-row>
  } @else {
    <ion-row class="ion-margin-top">
      <ion-col>
        <div class="panel-border">
          <ion-row>
            <ion-col class="ion-text-center ion-margin-top ion-margin-bottom">
              <ion-label class="panel-label-text">
                {{ 'devices_noResult' | translate }}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="ion-text-center ion-margin-bottom">
              <ion-button
                color="primary"
                class="ion-align-self-center"
                (click)="openAddDeviceModal()"
              >
                <small>{{ 'device_addDevice' | translate }}</small>
              </ion-button>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
  }
</ion-grid>
